export class VirtualReference {
  constructor({ clientRect }) {
    this.clientRect = clientRect
  }

  getBoundingClientRect() {
    return this.clientRect
  }

  get clientWidth() {
    return this.getBoundingClientRect().width
  }

  get clientHeight() {
    return this.getBoundingClientRect().height
  }
}
